<template>
  <van-popup :value="true" :closeable="false" :close-on-click-overlay="false" class="popup-cashmatic" @close="onClose" @open="onOpen">
    <h2 class="info-center">Gestione pagamento elettronico</h2>
    <template v-if="sceltaPagamento">
      <div class="spacer" />
      <template>
        <van-row type="flex" justify="space-around" class="mt-5">
          <van-button v-for="(tml, idx) of terminali" :key="idx" type="primary" @click="pagamentoElettronico(tml)">{{tml.descrizione}}<div class="small-text black">continua il pagamento sul dispositivo</div></van-button>
        </van-row>
      </template>
      <van-row type="flex" justify="space-around" class="annulla-pagamento">
        <van-button type="danger" plain size="small" @click="annullaPagamento">ANNULLA IL PAGAMENTO<div class="small-text">interrompe l'operazione</div></van-button>
      </van-row>
    </template>
    <template v-else>
      <h3 class="info-center red blink" v-if="errorePos">ATTENZIONE! VERIFICARE IL DISPOSITIVO !!</h3>
      <div class="spacer" />
      <van-row type="flex" justify="space-around">
        <h4 class="info-center blink blu" v-if="!errorePos">ESEGUIRE IL PAGAMENTO SUL DISPOSITIVO !</h4>
      </van-row>
      <div class="spacer" />
      <van-row type="flex" justify="space-around">
        <h2 class="info-center red" v-if="operazione">{{ operazione }} !!!</h2>
      </van-row>
      <van-row type="flex" justify="space-around" >
        <van-button type="warning" plain size="small" v-if="abilitaChiusuraManuale" @click="pagaManuale" class="conferma-pagamento">CONFERMA PAGAMENTO<div class="small-text">conferma esecuzione manuale</div></van-button>
        <van-button type="danger" plain size="small" @click="annullaPagamento" class="annulla-pagamento">ANNULLA IL PAGAMENTO<div class="small-text">interrompe l'operazione</div></van-button>
      </van-row>
    </template>
  </van-popup>
</template>

<script>
/* eslint-disable */
import configurazioni from '@/services/configurazioniService.js'
import ingenico from '@/services/custom/ingenico.js'
import logger from '@/services/loggerService.js'
import _ from 'lodash'

export default {
  props: {
    context: Object
  },
  data() {
    return {
      timerStato: null,
      statoTransazione: null,
      importoRichiesto: '',
      importoInserito: '',
      restoErogato: '',
      restoNonErogato: '',
      sceltaPagamento: true,
      abilitaChiusuraManuale: false,
      posLastTransaction: null,
      terminali: [],
      operazione: '',
      errorePos: false,
      terminaleScelto: null
    }
  },
  async mounted() {
    this.terminali = await configurazioni.getConfigurazione('terminaliPos', 'terminali')
    this.sceltaPagamento = this.mostraSceltaPagamento
    if (!this.sceltaPagamento) {
      await this.$nextTick()
      await this.pagamentoElettronico()
    }
  },
  computed: {
    importoDaPagare() {
      return (this.context.daPagareTotale || this.context.totaleScontrino)
    },
    periodoPolling() {
      return _.get(this.context, 'impostazioni.cassa.pos.pollingMs', 1000)
    },
    mostraSceltaPagamento() {
      return _.get(this.context, 'impostazioni.cassa.pos.mostraSceltaPagamento', true)
    }
  },
  methods: {
    onOpen() {
      this.sceltaPagamento = this.mostraSceltaPagamento
    },
    onClose() {
      // verificare
      if (this.timerStato) {
        logger.log("Chiudi!", "pos", 'close')
        clearInterval(this.timerStato)
        this.timerStato = null
      }
    },
    /*     chiudi() {
      if (this.timerStato) {
        clearInterval(this.timerStato)
      }
      this.$emit('close')
    }, */
    pagaManuale() {
      this.posLastTransaction = null
      this.stampaScontrino()
    },
    async pagamentoElettronico(terminale) {
      this.terminaleScelto = terminale
      this.sceltaPagamento = false
      this.errorePos = false
      // const centesimi = Math.round(parseFloat(this.importoDaPagare) * 100)
      const result = await ingenico.richiestaPagamento(terminale, this.importoDaPagare)
      
      logger.log(JSON.stringify(result), "pos", 'richiestaPagamento')
      if (result.error) {
        this.operazione = 'Servizio POS non raggiungibile'
        this.abilitaChiusuraManuale = true
        return
      }
      logger.log('setta intervallo', "pos", 'interval')
      this.timerStato = setInterval(async () => {
        const st = await ingenico.getStatoOperazione()
        logger.log(JSON.stringify(st), "pos", "polling")
        this.statoTransazione = st
        // this.aggiornaDisplay(st)
        if (st.tipo !== 'idle') {

          clearInterval(this.timerStato)
          this.timerStato = null
          if (st.tipo === 'operazione') {
        logger.log("chiusura manuale, errore", "pos", "polling")
            this.operazione = this.getMessaggioOperazione(st.messaggio)
            this.abilitaChiusuraManuale = true
            this.errorePos = true
          } else if (st.tipo === 'pagamento') {
            // TODO concludere il pagamento OK
        logger.log("cpagamento concluso", "pos", "polling")
            this.posLastTransaction = st.pagamento
        logger.log("Stampa scontrino", "pos", "polling")

            this.stampaScontrino()
          }
        } else {
          this.operazione = 'Attesa operazione ...'
        }
      }, this.periodoPolling)
    },
    getMessaggioOperazione(messaggioOriginale) {
      let messaggio = ''
      // Inserire eventuali altri messaggi da integrare
      switch (messaggioOriginale) {
        case 'Disponib insuff':
          messaggio = 'Disponibilità insufficiente'
          break
        default:
          messaggio = messaggioOriginale
      }
      return messaggio
    },
    async annullaPagamento() {
      if (this.timerStato) {
        clearInterval(this.timerStato)
      }
      await ingenico.resetConnessione(this.terminaleScelto)
      var ev = {
        type: 'POS_PAGAMENTO_ANNULLATO'
      }
      this.$emit('send-event', ev)
      this.posLastTransaction = null
      this.terminaleScelto = null
    },
    stampaScontrino(pagamento) {
      if (this.timerStato) {
        clearInterval(this.timerStato)
      }
      var ev = {
        type: 'POS_PAGAMENTO_EFFETTUATO',
        payload: this.posLastTransaction
      }
      this.$emit('send-event', ev)
      this.posLastTransaction = null
      this.terminaleScelto = null
    }
  }
}
</script>

<style lang="scss" scoped>

  .popup-cashmatic {
    width: 40vw;
    height: 60vh; /* 47 Attenzione lasciare spazio per pulsanti aggiornamento */
  }

  @media all and (max-width: 1800px) {
    .popup-cashmatic {
      width: 50vw;
      height: 67vh;
    }
  }

  @media all and (max-width: 1400px) {
    .popup-cashmatic {
      width: 55vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  @media all and (max-width: 1024px) {
    .popup-cashmatic {
      width: 80vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
    }
  }

  .info-center {
    text-align: center;
    &.red {
      color: red;
    }
    &.orange {
      color: #ff8800;
    }
    &.blu {
      color: #0202d8
    }
  }

  .cash-testo {
    font-weight: bold;
    color: black;
    &.cash-errore {
      color: red;
    }
  }

  .popup-stampante .van-cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .blink {
    animation: blinker 1s step-start infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  .small-text {
    font-size:x-small;
    &.black {
      color: black;
    }
  }
  .mt-5 {
    margin-top: 50px;
  }
  .annulla-pagamento {
    bottom: 20px;
    top: auto;
    position: absolute;
    right: 30px;
  }
  .conferma-pagamento {
    bottom: 20px;
    top: auto;
    position: absolute;
    left: 30px;
  }

  .spacer {
    height: 50px;
  }

</style>

<style lang="scss" scoped>
 /*
  @import "../modale.scss";
  @import "./style.scss";

  div[name="ModaleCashmatic"] {
    width: 40vw;
    height: 50vh;

    top: 25vh;
    left: 30vw;
  }

  .c-left {
    justify-self: left;
  }
  .c-right {
    justify-self: right;
  }

  .labelErrore {
    color: red;
    font-weight: bold;
  }

  table.cashmatic-result {
    & tr {
      height: 30px;
      & td.cashmatic-importo {
        text-align: right;
      }
    }
  }
*/
</style>
